"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utils_1 = require("@mui/material/utils");
var SvgWaterEnergy = (0, utils_1.createSvgIcon)(react_1.default.createElement(react_1.default.Fragment, {}, react_1.default.createElement("path", { d: "M11 18h1l4-6h-3V8h-1l-4 6h3v4Zm1 4c-2.283 0-4.188-.783-5.713-2.35C4.763 18.083 4 16.133 4 13.8c0-1.667.662-3.48 1.987-5.438C7.313 6.405 9.317 4.284 12 2c2.683 2.283 4.688 4.404 6.012 6.363C19.337 10.32 20 12.133 20 13.8c0 2.333-.762 4.283-2.288 5.85C16.188 21.217 14.283 22 12 22Z" })), 'SvgWaterEnergy');
exports.default = SvgWaterEnergy;
